<template>
  <div>
    <h4>Transactions List</h4>
    <div class="justify-content-between d-flex mb-4">
      <div class="d-flex align-items-center">
        <slot name="all-agents"></slot>
        <slot name="all-trans"></slot>
        <div class="filter refresh" @click="refreshData">
          <span>Refresh</span>
          <svg
            :class="{ rotate: rotateIcon }"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#A5A5A5"
          >
            <path
              d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
        <div class="filter" @click="toggleFilter" v-if="!isAgentList">
          <img src="./../assets/icons/filter.svg" alt="" />
          <span>Filter</span>
          <img
            src="./../assets/icons/arrow-down.svg"
            alt=""
            style="margin-top: 3px"
          />
        </div>
        <div class="search-form search-form-agent d-none">
          <slot name="search-bar"></slot>
          <img
            class="eye d-none"
            src="./../assets/icons/eye-visible.svg"
            alt="Search"
          />
          <slot name="search-btn"></slot>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <span class="pr-1">Showing</span>
        <!-- <div class="filter show">
          <slot name="select-entry"></slot>
        </div> -->
        <slot name="entries-no"></slot>
      </div>
    </div>
    <div
      id="filterModal"
      class="filter-modal"
      :class="{ 'filter-fade': showFilterModal }"
    >
      <div class="filter-param">
        <span>Date</span>
        <b-row class="align-items-center justify-content-between">
          <b-col class="flex-grow-0">
            <slot name="start-date" :closeModal="toggleFilter"></slot>
          </b-col>
          <span>-</span>
          <b-col class="flex-grow-0">
            <slot name="end-date"></slot>
          </b-col>
        </b-row>
      </div>
      <div>
        <p class="d-none">POS Transaction Value (₦)</p>
        <div class="filter-param d-none">
          <b-form-input
            class="mb-3"
            id="range-1"
            type="range"
            min="0"
            max="5"
          ></b-form-input>
          <b-row class="align-items-center">
            <b-col>
              <slot name="start-range"></slot>
            </b-col>
            <span>-</span>
            <b-col>
              <slot name="end-range"></slot>
            </b-col>
          </b-row>
        </div>
        <p>Name, Agent ID or Terminal ID</p>
        <div class="filter-param">
          <b-row class="align-items-center">
            <b-col>
              <slot name="agent-input"></slot>
            </b-col>
          </b-row>
        </div>
        <!-- <slot name="save-default"></slot> -->
      </div>
      <div class="filter-param">
        <b-row class="align-items-center">
          <b-col>
            <slot name="clear-btn"></slot>
          </b-col>
          <b-col>
            <slot name="apply-btn" :closeModal="toggleFilter"></slot>
          </b-col>
        </b-row>
      </div>
    </div>
    <slot name="table"></slot>
    <slot name="pagination"></slot>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showFilterModal: false,
      isAgentList: "",
      rotateIcon: false,
    };
  },
  methods: {
    ...mapActions({
      refreshPinpad: "pinpad/refresh",
      refreshPos: "pos/refresh",
      refreshBankTransfer: "bankTransfer/refresh",
      refreshAccounts: "accounts/refresh",
      refreshAgentList: "agentList/refresh",
    }),
    toggleFilter() {
      this.showFilterModal = !this.showFilterModal;
    },
    refreshData() {
      this.rotateIcon = true;
      this.refreshPinpad();
      this.refreshPos();
      this.refreshBankTransfer();
      this.refreshAccounts();
      this.refreshAgentList();
      setTimeout(() => {
        this.rotateIcon = false;
      }, 3000);
    },
  },
  created() {
    this.$router.history.current.name === "AgentList"
      ? (this.isAgentList = true)
      : (this.isAgentList = false);
  },
};
</script>

<style lang="scss">
.dropdown-menu {
  background: #fff;
}
</style>
